import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import _ from 'lodash';
import { Location } from '../interfaces/location';

import { from, Observable, Subject } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { ConnectionStatus, NetworkService } from './network.service';
import { OfflineManagerService } from './offline-manager.service';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class LocationService {
  locationDataSubject = new Subject();
  locationSave = new Subject();

  constructor(
    private http: HttpClient,
    private network: NetworkService,
    private offlineManager: OfflineManagerService,
    private storage: Storage
  ) { }

  // TODO: hier bitte die neuen Services umschreiben auf Observable##############################################################################################
  // TODO: hier bitte die neuen Services umschreiben auf Observable##############################################################################################

  getAllLocations(companyId): Observable<any> {
    return this.http.get(`${environment.url}/bucket/${environment.buckets.locations}/data?filter={"company":"${companyId}"}&relation=true`)
  }

  getLocationById(locationId): Observable<any> {
    return this.http.get(`${environment.url}/bucket/${environment.buckets.locations}/data/${locationId}`)
  }

  saveLocation(location): Observable<any> {
    // TODO:überprüfen was kommt und die Id mitgeben
    // console.log('EvemtTyüe', eventType._id.length);//todo:lenght funktioniert nicht
    if (location._id) {
      const flated = this.flatLocation(location);
      return this.updateLocation(flated);
    } else {
      console.log('COMPANY_KEY: ', location.company);
      return this.addLocation(location);
    }
  }

  private updateLocation(location: any): Observable<any> {// FUNKTIONIERT
    return this.http.put<any>(
      `${environment.url}/bucket/${environment.buckets.locations}/data/${location._id}`,
      location
    );
  }

  private addLocation(location: any): Observable<any> {
    return this.http.post<any>(
      `${environment.url}/bucket/${environment.buckets.locations}/data`,
      location
    );
  }

  deleteLocation(loc) {
    return this.http.delete(`${environment.url}/bucket/${environment.buckets.locations}/data/${loc._id}`)
  }

  // TODO: Flaten von Objekt
  flatLocation(location) {
    if (typeof location.company !== "string")
      location.company = location.company._id;//flaten funktioniert
    console.log('flatLocation:', location);
    return location;
  }

  // TODO: hier bitte die neuen Services umschreiben auf Observable##############################################################################################
  // TODO: hier bitte die neuen Services umschreiben auf Observable##############################################################################################

  getLocationsWithRelation(companyId: string, filterHiddens: boolean = true): Observable<Location[]> {
    return this.network.onNetworkChange().pipe(
      switchMap((status: ConnectionStatus) => {
        if (status === ConnectionStatus.Online) {
          return this.http
            .get<Location[]>(
              // tslint:disable-next-line: max-line-length
              `${environment.url}/fn-execute/employees?filterHiddens=${filterHiddens}&company_id=${companyId}`
            )
            .pipe(
              tap(employees => {
                this.storage.set(environment.storage.allEmployeesWithRelation, employees);
              })
            );
        } else {
          return this.storage.get(environment.storage.allEmployeesWithRelation);
        }
      })
    );
  }

  // deleteLocation(emp): Promise<any> {
  //   return new Promise<any>((resolve, reject) => {
  //     this.http.delete(`${environment.url}/bucket/${environment.buckets.locations}/data/${emp._id}`).subscribe(res => {
  //       resolve(res);
  //     }, err => reject(err));
  //   })
  // }

  convertToLocale(time: string) {
    return moment.utc(time, 'HH:mm').local().format('HH:mm');
  }

  convertToServerTime(time: string) {
    if (/^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/.test(time)) {
      return moment(time, 'HH:mm').utc().format('HH:mm');
    } else {
      return moment(time).utc().format('HH:mm');
    }
  }

  getLocations(companyId: string, relation = false): Observable<Location[]> {
    return this.network.onNetworkChange().pipe(
      switchMap((status: ConnectionStatus) => {
        if (status === ConnectionStatus.Online) {
          let url = `${environment.url}/bucket/${environment.buckets.locations
            }/data?relation=services&relation=ressource_group&filter={"${relation ? 'company._id' : 'company'
            }":"${companyId}", "active":true}`;
          // console.log('URL: ', url);
          return this.http.get<Location[]>(url).pipe(
            tap(employees => {
              this.storage.set(environment.storage.allEmployees, employees);
            })
          );
        } else {
          return this.storage.get(environment.storage.allEmployees);
        }
      })
    );
  }



  // updateLocation(location: Location): Observable<Location> {
  //   return this.http.put<Location>(
  //     `${environment.url}/bucket/${environment.buckets.locations}/data/${location._id}`,
  //     location
  //   );
  // }

  // insertLocation(employee: Location): Observable<Location> {
  //   return this.http.post<Location>(
  //     `${environment.url}/bucket/${environment.buckets.locations}/data`,
  //     employee
  //   );
  // }




}

